import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    LinearProgress,
    Fab,
    Stack,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { useSelector } from "react-redux";
import UserStatsCardSkeletonWeb from "../../Components/reports/UserStatsCardSkeleton";
import UserStatsCardWeb from "../../Components/reports/UserStatsCard";
import { getReports } from "../../Slices/reports";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Footer } from "../../Components/Footer";


// import { printToFileAsync, printAsync } from "../../Utils/printUtils";

const ReportsWeb = () => {
    // const userId = useSelector((state) => state.auth.user?.user.id);
    // const token = useSelector((state) => state.auth.user?.jwt);

    const { user, accessToken: token } = useSelector((state) => state.auth);


    const [reports, setReports] = useState([]);
    const [userStatuses, setUserStatuses] = useState({});
    const [myStatus, setMyStatus] = useState("offline");
    const [vrProgress, setVrProgress] = useState(null);

    useEffect(() => {
        if (!token) return;

        const fetchReports = async () => {
            try {
                const res = await getReports(user.id, token);
                setReports(res);
            } catch (error) {
                console.error("Błąd pobierania raportów:", error);
            }
        };
        fetchReports();
    }, [token, user.id]);

    const printReport = async () => {
        try {
            const element = document.getElementById("report");

            if (!element) {
                console.error("Nie znaleziono elementu raportu");
                return;
            }

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#f8fafc",
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight =
                (canvas.height * pdfWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(
                imgData,
                "PNG",
                0,
                position,
                imgWidth,
                imgHeight
            );

            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;

                pdf.addPage();

                pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );

                heightLeft -= pdfHeight;
            }

            const blob = pdf.output("blob");
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

        } catch (error) {
            console.error("Błąd podczas drukowania raportu:", error);
        }
    };


    const downloadPdf = async () => {
        try {
            const element = document.getElementById("report");

            if (!element) {
                console.error("Nie znaleziono elementu raportu");
                return;
            }

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#f8fafc",
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight =
                (canvas.height * pdfWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(
                imgData,
                "PNG",
                0,
                position,
                imgWidth,
                imgHeight
            );

            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;

                pdf.addPage();

                pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );

                heightLeft -= pdfHeight;
            }

            pdf.save(
                `lista-raportów.pdf`
            );

        } catch (error) {
            console.error("Błąd podczas generowania PDF:", error);
        }
    };

    return (
        <>
            <Box id="report" sx={{ p: 3 }}>
                {/* <Box sx={{ mb: 3 }}>
                <Typography variant="h6">Status użytkowników:</Typography>
                <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                    {Object.entries(userStatuses).map(([id, status]) => (
                        <Typography key={id}>
                            User {id}: <strong>{status}</strong>
                        </Typography>
                    ))}
                    <Box
                        sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            bgcolor: myStatus === "online" ? "green" : "red",
                        }}
                    />
                    <Typography>{myStatus}</Typography>
                </Stack>
            </Box> */}

                {vrProgress?.show && (
                    <Card sx={{ mb: 3 }}>
                        <CardContent>
                            <Typography align="center">
                                Rozpoczęto scenariusz VR {vrProgress?.scenario}
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={vrProgress?.progress || 0}
                                sx={{ height: 20, borderRadius: 2, my: 1 }}
                            />
                            <Typography align="center">Progress: {vrProgress?.progress}%</Typography>
                        </CardContent>
                    </Card>
                )}

                {vrProgress && <UserStatsCardSkeletonWeb vrProgress={vrProgress} />}

                <Stack spacing={2}>
                    {reports?.map((report) => (
                        <Box key={report.id} sx={{ mb: 0, backgroundColor: 'transparent' }}>
                            <UserStatsCardWeb report={report} reports={reports} />
                        </Box>
                    ))}
                </Stack>

                <Stack direction="row" spacing={2} mt={3} justifyContent="center">
                    <Fab color="primary" variant="extended" onClick={downloadPdf}>
                        <DownloadIcon sx={{ mr: 1 }} /> Pobierz PDF
                    </Fab>
                    <Fab color="secondary" variant="extended" onClick={printReport}>
                        <PrintIcon sx={{ mr: 1 }} /> Drukuj
                    </Fab>
                </Stack>
            </Box>
            <Footer />
        </>
    );
};

export default ReportsWeb;
